export default __webpack_public_path__ + "static/media/oldLogo.e266e9af.png";